// src/lib/proprio-nom-logement.js — LE NOM D'UN LOGEMENT, TEL QUE LE
// PROPRIÉTAIRE LE LIT (30/09).
//
// Règle maison : jamais un identifiant technique à l'écran d'un client. Or le
// serveur (`proprio_logements`, lib/proprio-handlers.js) renvoie
// `nom: l.nom || l.id` — un logement sans nom arrive donc avec son CODE
// (« l3 ») dans le champ `nom`, et tout écran qui affiche `logement.nom` tel
// quel le montre. Le propriétaire ne lit pas la config (cloisonnement) : il n'a
// que cette liste, c'est donc ici qu'on refuse le code.
//
// Nom actuel s'il existe et n'est pas le code ; sinon « Votre logement ».

export const NOM_LOGEMENT_REPLI = 'Votre logement'

export function nomLogementProprio(logement) {
  if (!logement) return NOM_LOGEMENT_REPLI
  const nom = typeof logement.nom === 'string' ? logement.nom.trim() : ''
  if (!nom) return NOM_LOGEMENT_REPLI
  if (logement.id != null && nom === String(logement.id).trim()) return NOM_LOGEMENT_REPLI
  return nom
}
